<template>
  <div class="accidentRescueLog">
    <div class="center">
      <div class="cell">
        <div>调度时长：</div>
        <div class="time">{{ formatSeconds(orderRoute.dispatchTimeSlot) }}</div>
      </div>
      <div class="cell">
        <div>到达时长：</div>
        <div class="time">{{ formatSeconds(orderRoute.arriveTimeSlot) }}</div>
      </div>
      <div class="cell">
        <div>作业时长：</div>
        <div class="time">{{ formatSeconds(orderRoute.operationTimeSlot) }}</div>
      </div>
    </div>
    <div class="center">
      <van-steps
        direction="vertical"
        :active="9"
        active-color="#646464"
        inactive-color="#38f"
      >
        <van-step>
          <h3>接单时间：{{ orderRoute.takeTime }}</h3>
          <div class="mileageCenter">
            <span class="mileage gray">
              预估里程{{ m2km(orderRoute.takeOrderDistance) }}km
            </span>
          </div>
          <div class="mileageCenter">
            <span class="mileage blue">
              实际行驶里程{{ m2km(orderRoute.arriveMileage ? orderRoute.arriveMileage : orderRoute.actualTakeOrderDistance) }}km
            </span>
          </div>
        </van-step>
        <van-step>
          <h3>到达现场时间：{{ orderRoute.arriveTime }}</h3>
          <div class="mileageCenter">
            <span class="mileage gray">
              预估里程{{ m2km(orderRoute.operationOrderDistance) }}km
            </span>
          </div>
          <div class="mileageCenter">
            <span class="mileage blue">
              实际行驶里程{{ m2km(orderRoute.orderMileage ? orderRoute.orderMileage : orderRoute.actualOperationOrderDistance) }}km
            </span>
          </div>
        </van-step>
        <van-step>
          <h3>完成作业时间：{{ orderRoute.operationfinishTime }}</h3>
        </van-step>
        <van-step>
          <h3>服务完成时间：{{ orderRoute.serviceFinishTime }}</h3>
        </van-step>
      </van-steps>
    </div>
  </div>
</template>
<script>
// import Utils from '@/common/util.js';
export default {
  props: {
    orderRoute: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {};
  },
  methods: {
    m2km(distance) {
      return (distance / 1000).toFixed(1);
    },
    formatSeconds(value) {
      let theTime = value || 0; // 秒
      let middle = 0; // 分
      let hour = 0; // 小时

      if (theTime > 60) {
        middle = parseInt(theTime / 60);
        theTime = parseInt(theTime % 60);
        if (middle > 60) {
          hour = parseInt(middle / 60);
          middle = parseInt(middle % 60);
        }
      }
      let result = '';
      theTime = parseInt(theTime);
      middle = parseInt(middle);
      hour = parseInt(hour);
      if (hour === 0) {
        result = theTime + '秒';
        if (middle !== 0) {
          result = middle + '分钟' + result;
        }
      } else {
        result = theTime + '秒';
        result = middle + '分钟' + result;
        result = hour + '小时' + result;
      }

      return result;
    }
  }
};
</script>
<style lang="scss" scoped>
.accidentRescueLog{
  height: 100vh;
  .center{
    width: 94vw;
    background: #fff;
    border-radius: 0.2rem;
    margin: 0.3rem auto;
    padding: 0.3rem;
    box-sizing: border-box;
    .cell{
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 0.30rem;
      color: #646464;
      height: 0.6rem;
      line-height: 0.6rem;
      .time{
        color: #383838;
        font-weight: 500;
      }
    }
  }
  .mileageCenter{
    margin-top: 0.2rem;
  }
  .mileage{
    // border: 1px solid #999;
    // background: #F3F3F3;
    // color: #787878;
    // display: flex;
    padding: 0.15rem 0.2rem;
    margin-top: 0.2rem;
    display: inline-block;
    border-radius: 0.05rem;
    position: relative;
    &::before{
      content: '';
      width: 0.2rem;
      height: 0.2rem;
      // border: 1px solid #999;
      position: absolute;
      left: -0.14rem;
      top: 0.2rem;
      transform:rotate(45deg);
      background: #F3F3F3;
      border-right: none;
      border-top: none;
    }
  }
  .gray{
    border: 1px solid #999;
    background: #F3F3F3;
    color: #787878;
    &::before{
      border: 1px solid #999;
      border-right: none;
      border-top: none;
    }
  }
  .blue{
    border: 1px solid #3399FF;
    background: #F2F9FF;
    color: #3399FF;
    &::before{
      border: 1px solid #3399FF;
      border-right: none;
      border-top: none;
    }
  }
}
</style>
